import logger from "../../art-logger-config";
import { getUser } from "../app/api";

const unknownUser = "unknown";
let user = unknownUser;
export type Feature =
  | "searchSideBar"
  | "filterBar"
  | "stamper"
  | "publishCorrectCatalogDefault"
  | "passException"
  | "asinCentralTable"
  | "validationTable"
  | "validationDashboardTable"
  | "validationTabs"
  | "stepBreakdown"
  | "programTickets"
  | "catalogIssues"
  | "baselineTable"
  | "oneClickLaunchTable"
  | "noFiltersPanel"
  | "appShell";

async function getAmazonAlias() {
  if (user === unknownUser) {
    const response = await getUser();

    user = response.requester.identity;
  }
  return user;
}

export async function trackButtonClick(
  feature: Feature,
  buttonName: string,
  data = JSON.parse("{}")
) {
  logger.info(
    `Button Click: { button: "${feature}.${buttonName}", user: "${await getAmazonAlias()}", data:${unescape(
      JSON.stringify(data)
    )}`
  );
}

export async function trackComponentView(
  feature: Feature,
  componentName: string,
  data = JSON.parse("{}")
) {
  logger.info(
    `Component View: { component: "${feature}.${componentName}", user: "${await getAmazonAlias()}", data:${unescape(
      JSON.stringify(data)
    )}`
  );
}
